import { CHAPTERS_FETCH_SUCCESS } from '../constants';

export function chapters(state = [], action) {
  switch (action.type) {
    case CHAPTERS_FETCH_SUCCESS:
      return action.chapters;
    default:
      return state;
  }
}
